import 'bootstrap/dist/css/bootstrap.min.css';
import RouteList from './component/layout/RouteList';
import { BrowserRouter } from "react-router-dom";
import '../src/assets/css/custom.css';
import '../src/assets/css/responsive.css'
import "react-toastify/dist/ReactToastify.css";
import Header from './component/layout/Header';
import Footer from './component/layout/Footer';

function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
          <RouteList />
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
